<template>
<div>
  <template>
    <div class="main-loading" v-if="isLoading"><adx-loading-primary /></div>
    <div v-if="!isLoading" class="busCampaignEditor">
      <div class="busCampaignEditor__header">
        <div class="busCampaignEditor__header--left">
          <h2 class="large-title">Campaign Editor</h2>
          <p>Set your campaign details</p>
        </div>
      </div>
      <div v-if="isLoading && model.id == null" class="busCampaignEditor__loading">
        <adx-loading slot="loading" />
      </div>
      <div v-if="!isLoading" class="busCampaignEditor__content">
        <div class="busCampaignEditor__content--left">
          <div class="busCampaignEditor__content--section">
            <div class="busCampaignEditor__content__row">
              <adx-input label="Campaign Name" :value.sync="model.campaignInput" :validation="['NotEmpty','NewMinLength:3', 'NewMaxLength:50']" :error.sync="errors.campaignInput" :ref="dataRef.campaignInput"/>
            </div>
            <div class="busCampaignEditor__content__row">
              <div class="busCampaignEditor__content__row__left">
                <adx-select-dropdown label="Period of Campaign" :value.sync="model.periodDropdown" :options="periodOptions" :error.sync="errors.periodDropdown" :ref="dataRef.periodDropdown"/>
              </div>
              <div class="busCampaignEditor__content__row__right">
                <div class="calendar">
                  <label>Start Date</label>
                  <v-date-picker
                    v-model='model.startInput'
                    :min-date='today'
                    :popoverVisibility="'focus'"
                    class='date-input'>
                    <input
                      class="calendar-start"
                      placeholder= "DD/MM/YYYY"
                      type='text'
                      slot-scope='{ inputValue, updateValue }'
                      :value='inputValue'
                      @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                      @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
                  </v-date-picker>
                </div>
              </div>
            </div>
          </div>
          <div class="busCampaignEditor__content--section">
            <div class="title subhead">Contact Information</div>
            <div class="busCampaignEditor__content__row">
              <adx-input label="Company Name *" :value.sync="model.companyInput" :validation="['NotEmpty','NewMinLength:2', 'NewMaxLength:256', 'Alphanumeric']" :error.sync="errors.companyInput" 
              :class="[error.companyInput && model.companyInput == null ? 'warning' : '']" :ref="dataRef.companyInput" />
            </div>
            <div class="busCampaignEditor__content__row">
              <div class="busCampaignEditor__content__row__left">
                <adx-input label="Contact Person *" :value.sync="model.contactInput" :validation="['NotEmpty','NewMinLength:2', 'NewMaxLength:256', 'Alphanumeric']" :error.sync="errors.contactInput"
                :class="[error.contactInput && model.contactInput == null ? 'warning' : '']" :ref="dataRef.contactInput"/>
              </div>
              <div class="busCampaignEditor__content__row__right">
                <adx-input label="Phone Number *" :value.sync="model.phoneInput" :validation="['NotEmpty','NewMinLength:7', 'NewMaxLength:15', 'Phone']"       
                :class="[error.phoneInput && model.phoneInput == null ? 'warning' : '']" :ref="dataRef.phoneInput"/>
              </div>
            </div>
          </div>
          <div class="busCampaignEditor__content--section">
              <div class="title subhead">Sales Account</div>
              <div class="busCampaignEditor__content__row">
                <adx-input label="Sales Names " :value.sync="model.salesInput" :validation="['NotEmpty', 'NewMaxLength:100', 'Alphanumeric']" :error.sync="errors.salesInput"
                :class="[error.salesInput && model.salesInput == null ? 'warning' : '']" :ref="dataRef.salesInput"/>
              </div>
            </div>
          <div class="busCampaignEditor__content--section" v-for="(item, index) in items" :key="index">
            <div class="busCampaignEditor__content__row1">
              <div class="groups">
                <div class="group">
                    <span v-if ="item.bus.route" class="subhead route">{{ item.bus.route.title}}</span>
                    <span v-else class="subhead route"> - </span>
                    <span v-if ="item.bus.generic" class="subhead placement">{{ item.bus.generic.title }} - {{ item.count }}</span>
                    <span v-else class="subhead placement"> - </span>
                </div>
                <div class="group--type2">
                  <div class="smallDropdown">
                    <adx-select-dropdown type="small" :value.sync="item.count" :options="amountOptions" :selected="selectedValue(item)"/>
                  </div>
                </div>
              </div>
              <div class="groups">
                <div class="group--type3">
                  <div class="priceWrapper">
                    <span class="label">Price</span>
                    <span class="price">{{ item.bus.generic.price * item.count | formatMoney }}</span>
                  </div>
                </div>
                <div class="group--type4">
                  <div class="imageWrapper">
                    <img @click="deleteItem(items, index)" src="/img/adxicon/ic-delete.png" alt="">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="busCampaignEditor__content--button">
            <button class="btn-small secondary add" @click="addMore">Add More Items</button>
          </div>
        </div> 
        <div class="busCampaignEditor__content--right">
          <div class="busCampaignEditor__content--section">
            <div class="subhead title head">Order Summary</div>
            <div class="busCampaignEditor__content__row2">
              <span class="label">Subtotal Price</span>
              <!-- <span class="price">{{ getTotalPriceCampaign() | formatMoney }}</span> -->
              <span class="price">{{ getTotalPrice() | formatMoney }}</span>
            </div>
            <div class="busCampaignEditor__content__row2">
              <span class="label">PPN 10%</span>
              <span class="price">{{ getPPN(getTotalPrice()) | formatMoney}}</span>
            </div>
            <div class="busCampaignEditor__content__row2">
              <span class="label">Total Price</span>
            </div>
            <div class="busCampaignEditor__content__row2">
              <span class="large-font totalPrice">{{ getTotalPriceCampaign() | formatMoney}}</span>
            </div>
            <div class="busCampaignEditor__content__row2">
              <button @click="checkout" class="btn-large primary checkout" >
                Save and Exit
                <adx-loading-2 v-if="saveLoading" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
</div>
</template>

<script>
import Loading from '@/components/Loading/Primary'
import LoadingWhite from '@/components/Loading/Secondary-white';
import Input from '@/components/Form/Input'
import SelectDropdown from '@/components/Form/SelectDropdown'
import File from '@/components/File'
import Modal from '@/components/Modal'
import LoadingPrimary from '@/components/Loading/Primary'

import * as validationLib from '@/lib/validation/'
import triggerValidation from '@/lib/triggerValidation'
import api from '@/api'
import { apiV2 } from '@/api/urls'
import lib from '@/lib/util'
import { parseErrorGql } from '@/lib/error'
import moment from 'moment'
import { mapGetters } from 'vuex'
const {
  helpers,
  validate
} = validationLib

export default {
  name: 'adx-bus-campaign-editor',
  components: {
    'adx-loading': Loading,
    'adx-input': Input,
    'adx-select-dropdown': SelectDropdown,
    'adx-file': File,
    'adx-modal': Modal,
    'adx-loading-2': LoadingWhite,
    'adx-loading-primary': LoadingPrimary
  },
  props: {

  },
  data() {
    return {
      total: 0,
      isLoading: false,
      total_generic: null,
      isInit: true,
      periodOptions: [],
      saveLoading: false,
      model: {
        id: null,
        campaignInput: null,
        periodDropdown: null,
        startInput: null,
        companyInput: null,
        contactInput: null,
        phoneInput: null,
        salesInput: null,
      },
      id: null,
      orderID: null,
      items: [],
      minimumPeriod: 0,
      minimumLeadTime: 0,
      amountOptions: [
        {
          label: "1 Bus",
          value: 1
        },
        {
          label: "2 Bus",
          value: 2
        },
        {
          label: "3 Bus",
          value: 3
        },
        {
          label: "4 Bus",
          value: 4
        },
        {
          label: "5 Bus",
          value: 5
        },
        {
          label: "6 Bus",
          value: 6
        },
        {
          label: "7 Bus",
          value: 7
        },
        {
          label: "8 Bus",
          value: 8
        },
        {
          label: "9 Bus",
          value: 9
        },
        {
          label: "10 Bus",
          value: 10
        },
        {
          label: "11 Bus",
          value: 11
        },
        {
          label: "12 Bus",
          value: 12
        },
        {
          label: "13 Bus",
          value: 13
        },
        {
          label: "14 Bus",
          value: 14
        },
        {
          label: "15 Bus",
          value: 15
        },
        {
          label: "16 Bus",
          value: 16
        },
        {
          label: "17 Bus",
          value: 17
        },
        {
          label: "18 Bus",
          value: 18
        },
        {
          label: "19 Bus",
          value: 19
        },
        {
          label: "20 Bus",
          value: 20
        }
      ],
      detail: null,
      dataRef:{
        campaignInput: "campaignInput",
        periodDropdown: "periodDropdown",
        companyInput: "companyInput",
        contactInput: "contactInput",
        phoneInput: "phoneInput",
        salesInput: "salesInput"
      },
      errors: {
        campaignInput: null,
        periodDropdown: null,
        startInput: null,
        companyInput : null,
        contactInput : null,
        phoneInput : null,
        salesInput: null
      },
       error: {
        companyInput : null,
        contactInput : null,
        phoneInput : null,
        salesInput: null
      },
    }
  },
  computed: {
    today() {
      var today = new Date();

      // if (this.minimumLeadTime>7){
      //   aWeekLater.setDate(aWeekLater.getDate() + this.minimumLeadTime);
      // } else{
      //   aWeekLater.setDate(aWeekLater.getDate() + 7);
      // }
      return today
    },
    ...mapGetters({
      token: 'token'
    }),
  },
  // apollo: {
  //   busCampaign: {
  //     query: require('@/graphql/bus/campaign.gql'),
  //     loadingKey: 'loading',
  //     errorPolicy: 'all',
  //     fetchPolicy: 'network-only',
  //     variables(){
  //       return {
  //         id: this.id,
  //       }
  //     },
  //     async result(data) {
  //       const { busCampaign } = await data.data
  //       //   if (busCampaign) {
  //       //     await this.mapData(busCampaign)
  //       // }
  watch: {
    'model.campaignInput': {
      handler: function () {
        (async () => {
          await this.capitalizeCampaign()
        })();
      },
      deep: true
    },
    'model.periodDropdown': {
      handler: async function (after, before) {
        let minimumPeriod = await this.minimumPeriod
        if(this.model.periodDropdown < minimumPeriod){
          this.model.periodDropdown = await minimumPeriod
          await this.$notify({
            group: 'saved',
            title: 'Error',
            text: 'Minimum period allowed for this campaign is ' + minimumPeriod + ' months',
            type: 'danger'
          });
        }
      },
      deep: true
    }
  },
  beforeCreate() {

  },
  created() {
    localStorage.setItem('apollo-token', this.token)
    this.getOptions()
    this.isLoading = true
    this.busCampaign()
  },
  beforeMount() {
   
  },
  mounted() {
    this.id = this.$route.params.id
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
     async busCampaign(){
      const  res = await  this.$apollo.query({
        query:require('@/graphql/bus/campaign.gql'),
        loadingKey:'loading',
        errorPolicy:'all',
        fetchPolicy:'network-only',
        variables:{
          id: this.$route.params.id
        }
      })
      if (res.data){
        if (res.errors){
          this.handleError(res.errors, 'campaign')
        } else{
          const { busCampaign } = await res.data
          if (busCampaign) {
            await this.mapData(busCampaign)
            this.isLoading = false
          }
        }
        this.isLoading = false
      }
    },
    showNotification(){
      this.$notify({
        group: 'saved',
        title: 'Error',
        text: `Something went wrong. Please refresh the page!`,
        type: 'danger'
      });
    },
    async handleError(errors, param){
      const parsedError = parseErrorGql(errors)
      if (parsedError.hasError){
        if (parsedError.code === 403 || parsedError.code === 404 || parsedError.code === 204){
          let code = parsedError.code
          if (parsedError.code === 204) code = 404
          this.$router.push({ name: `${code}` })
        }else if (parsedError.code === 502){
          switch(param){
            case 'campaign':
              this.count++
              if (this.count<3) {
                await this.busCampaign()
              } else{
                this.showNotification()
                await this.busCampaign()
                this.isLoading = false
              } 
              break;
            case 'checkout':
              this.countCheckout++
              if (this.countCheckout<3){
                this.$notify({
                  group: 'saved',
                  title: 'Error',
                  text: `Data failed to be saved!`,
                  type: 'danger'
                });
                this.saveLoading = false
              }
              break;
          }
        }else {
          this.$router.push({ name: `500` })
        }
      }
    },
    async getMinimumPeriod(){
      let minPeriod = 0
      await this.items.forEach(async el =>{
        let minPeriodBus = parseInt(el.bus.generic.minPeriod)
        if(minPeriodBus > minPeriod){
          minPeriod = minPeriodBus
        }
      })
      this.minimumPeriod = minPeriod
    },
    async getMinimumLeadTime(){
      let minLeadTime = 0
      this.items.forEach(el =>{
        let minLeadTimeBus = parseInt(el.bus.generic.leadPreCampaign)
        if(minLeadTimeBus > minLeadTime){
          minLeadTime = minLeadTimeBus
        }
      })
      this.minimumLeadTime = minLeadTime
    },
    async selectedValue(item){
      let minQuantity = item.bus.generic.minQuantity
      let count = item.count
      if (minQuantity > count){
        item.count = minQuantity
        await this.$notify({
            group: 'saved',
            title: 'Error',
            text: 'Minimum quantity allowed for this campaign is ' + minQuantity,
            type: 'danger'
          });
        
      }
    },
    async mapData(campaign){
      await this.getMinimumPeriod()
      await this.getMinimumLeadTime()
      this.orderID = await campaign.order.id
      this.model.id = await campaign.id
      this.model.campaignInput = await campaign.title
      this.model.companyInput = await campaign.companyName
      this.model.contactInput = await campaign.contactPerson
      this.model.phoneInput = await campaign.phoneNumber
      this.items = await campaign.orderRoutes || []
      this.model.startInput = await new Date(campaign.start)
      this.model.periodDropdown = await campaign.period 
      this.model.salesInput = campaign.order.sales
      this.isInit = false
      // if (this.aWeekLater > this.model.startInput){
      //   this.model.startInput = this.aWeekLater
      // }
      // if (this.minimumLeadTime > this.model.periodDropdown){
      //   this.model.periodDropdown = this.minimumLeadTime
      // }
    },
    getOptions() {
      this.getPeriod()
    },
    getPeriod() {
      let file = `/static/data/monthly_period.json`;
      (async () => {
        let request = await fetch(new Request(file))
        let data = await request.json()

        this.periodOptions = data.periods
      })();
    },
    addMore() { 
      this.$router.push({ name: 'buscampaigneditorbrowse' , params: {id: this.id , isEdit: 'edit', orderID: this.orderID }})
    },
    async deleteItem(items, index) {
      await items.splice(index, 1)
      await this.getMinimumLeadTime()
      await this.getMinimumPeriod()
    },
    capitalizeCampaign(){
      this.model.campaignInput = this.model.campaignInput.charAt(0).toUpperCase() + this.model.campaignInput.slice(1)
    },
    async checkout() {
      await this.checkoutCampaign()
    },
    async checkoutCampaign(){
      let validation1 = triggerValidation(this.model, this.dataRef, this.$refs, this.errors)
      if (validation1){
        const date = moment.utc(this.model.startInput).local().format('YYYY-MM-DD')
        let orderRoute = []
        await this.items.forEach(async (value) => {
         await orderRoute.push(
            {
              count: value.count,
              bus: {
                id: parseInt(value.bus.id)
              }
            }
          )
        })
        this.saveLoading = true
        const result = await this.$apollo.mutate({
          mutation: require('@/graphql/bus/campaignEdit.gql'),
          errorPolicy: 'all',
          variables: {
            id: this.model.id,
            campaign:{
            campaignInfo:{
              title : this.model.campaignInput,
              start: date,
              companyName: this.model.companyInput,
              contactPerson: this.model.contactInput,
              phoneNumber: this.model.phoneInput,
              period: this.model.periodDropdown,
              totalPrice : this.total.toString()
            },
            orderRoutes: orderRoute,
            sales: this.model.salesInput
            }
          }
        });
        if (result) {
           if(result.errors){
            this.handleError(result.errors, 'checkout')
            }else {
              this.saveLoading = false
              this.$notify({
              group: 'saved',
              title: 'Success',
              text: `Data successfully saved!`,
              type: 'success'
            });
            // await this.$apollo.queries.busCampaign.refetch()
            // await this.busCampaign()
            this.$router.push({ name: 'orderdetailexecution', params: { id: this.orderID }})
            }
        } else {
          this.$notify({
            group: 'saved',
            title: 'Error',
            text: `Data failed to save`,
            type: 'danger'
          });
        }
      }
    },
    getTotalPrice(){
      if (this.items.length > 0) {
        let total = 0
        this.items.map(x => {
         x.bus.generic ? total += (x.bus.generic.price * x.count) * this.model.periodDropdown : total = 0
        })
        this.total_generic = total
        return this.total_generic
      }
      return this.total_generic
    },
    getPPN(value){
      return value / 10
    },
    raiseError(errorMessage) {
      this.$notify({
        group: 'saved',
        title: 'Error',
        text: errorMessage,
        type: 'danger'
      });
    },
    getTotalPriceCampaign(){
      this.total = Math.round(this.getTotalPrice() + ((this.getTotalPrice() *10) / 100))
      return this.total
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

<style lang="scss">
@import '~@/styles/variables';
@import '~@/styles/mixins';

.busCampaignEditor {
  .popup {
    max-height: 300px;
    overflow-y: auto !important;
  }

  .selectDropdown {
    .select {
      input {
        height: 62px;
      }
    }
  }

  .smallDropdown {
    .selectDropdown {
      .select {
        width: 100px;

        input {
          height: 24px;
          width: 90px;
        }
      }

      .popup {
        max-width: 100px;

        .item {
          padding: 8px 8px;
        }
      }
    }
  }

  .title.large-font {
    font-size: 28px;
  }

  .modal__content__header{
    align-items: center;
    margin-bottom: 8px;
  }

  .modal__content__header{
    button {
      display: none;
    }
  } 
  
  a{
    color: #ff2d55;
  }
}
</style>